export default {
  namespaced: true,
  state: {
    userId: '',
    username: '',
    orgName:"",
    inviteQuota: 0
  },
  mutations: {
    updateId (state, userId) {
      state.userId = userId
    },
    updateName (state, username) {
      state.username = username
    },
    updateInviteQuota(state, inviteQuota) {
      state.inviteQuota = inviteQuota
    },
    updateOrgId(state, orgId) {
      state.orgId = orgId
    },
    SET_ORGNAME(state, orgName) {
      state.orgName = orgName
    }
  }
}
